module.exports = __webpack_public_path__ + "media/beep.516bcfcd.mp3";